import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import classNames from 'classnames';
import * as React from 'react';
import { Collapse } from 'components/Collapse/Collapse';
import { Experiments, PaymentCycle } from 'enums';
import { MonthlyDisclaimer } from '../MonthlyDisclaimer/MonthlyDisclaimer';
import { AscendBundleHelper } from './AscendBundleHelper';
import s from './Cycles.scss';

interface CycleHelperProps extends InjectedExperimentsProps {
  cycle: PaymentCycle;
  _disclaimerKey: string;
  isAscendBundle: boolean;
  features: any;
  showDisclaimer: boolean;
  isShown: boolean;
}

const CycleHelperComp: React.FC<CycleHelperProps> = ({
  cycle,
  isAscendBundle,
  features,
  showDisclaimer,
  isShown,
  experiments,
}) => {
  const isAscendBundleEnabeled = experiments.enabled(Experiments.AscendBundle);

  let helperToRender: React.ReactNode = null;

  if (PaymentCycle.YEARLY.includes(cycle)) {
    return null;
  }
  if (PaymentCycle.MONTHLY.includes(cycle) && showDisclaimer) {
    helperToRender = <MonthlyDisclaimer missingFeatureList={features} />;
  }
  if ([PaymentCycle.YEAR2, PaymentCycle.YEAR3].includes(cycle)) {
    if (isAscendBundleEnabeled && isAscendBundle) {
      helperToRender = <AscendBundleHelper />;
    } else {
      return null;
    }
  }

  if (helperToRender === null) {
    return null;
  }

  return (
    <Collapse
      isOpened={isShown}
      initialStyling={{
        width: '100%',
      }}
    >
      <div className={classNames(s.cycleHelper, { [s.withPadding]: isShown })}>
        {helperToRender}
      </div>
    </Collapse>
  );
};

export const CycleHelper = withExperiments(CycleHelperComp);
